webpackJsonp([22676092666560,60335399758886],{

/***/ 241:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(194);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(241);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 215:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var react_redux_2 = __webpack_require__(91);
	var store_2 = __webpack_require__(131);
	var semantic_ui_react_9 = __webpack_require__(21);
	exports.HeaderMenu = function (_ref) {
	    var items = _ref.items,
	        pathname = _ref.pathname,
	        Link = _ref.Link,
	        inverted = _ref.inverted,
	        dispatch = _ref.dispatch;
	    return React.createElement(semantic_ui_react_9.Container, null, React.createElement(semantic_ui_react_9.Menu, { size: "large", pointing: true, secondary: true, inverted: inverted }, React.createElement(semantic_ui_react_9.Menu.Item, { as: "a", className: "mobile only", icon: "sidebar", onClick: function onClick() {
	            return dispatch(store_2.toggleSidebar());
	        } }), React.createElement(semantic_ui_react_9.Menu.Item, { className: "mobile hidden" }, React.createElement(semantic_ui_react_9.Icon, { name: "spy", size: "big" })), items.map(function (item) {
	        var active = item.exact ? pathname === item.path : pathname.startsWith(item.path);
	        return React.createElement(semantic_ui_react_9.Menu.Item, { as: Link, className: "mobile hidden", name: item.name, to: item.path, key: item.path, active: active });
	    })));
	};
	exports.default = react_redux_2.connect()(exports.HeaderMenu);

/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __webpack_require__(1);
	var react_redux_3 = __webpack_require__(91);
	var semantic_ui_react_11 = __webpack_require__(21);
	exports.SidebarMenu = function (_ref) {
	    var items = _ref.items,
	        pathname = _ref.pathname,
	        Link = _ref.Link,
	        visible = _ref.visible;
	    var isActive = function isActive(item) {
	        return item.exact ? pathname === item.path : pathname.startsWith(item.path);
	    };
	    var activeItem = items.find(function (item) {
	        return isActive(item);
	    }) || {};
	    return React.createElement(semantic_ui_react_11.Sidebar, { as: semantic_ui_react_11.Menu, animation: "slide along", width: "thin", visible: visible, icon: "labeled", vertical: true, inverted: activeItem.inverted }, items.map(function (item) {
	        var active = isActive(item);
	        return React.createElement(semantic_ui_react_11.Menu.Item, { as: Link, to: item.path, active: active, key: item.path }, React.createElement(semantic_ui_react_11.Icon, { name: item.icon }), item.name);
	    }));
	};
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        visible: state.isSidebarVisible
	    };
	};
	exports.default = react_redux_3.connect(mapStateToProps)(exports.SidebarMenu);

/***/ }),

/***/ 216:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 217:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 218:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = function () {
	    function defineProperties(target, props) {
	        for (var i = 0; i < props.length; i++) {
	            var descriptor = props[i];
	            descriptor.enumerable = descriptor.enumerable || false;
	            descriptor.configurable = true;
	            if ("value" in descriptor) descriptor.writable = true;
	            Object.defineProperty(target, descriptor.key, descriptor);
	        }
	    }return function (Constructor, protoProps, staticProps) {
	        if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
	    };
	}();
	function _classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	        throw new TypeError("Cannot call a class as a function");
	    }
	}
	function _possibleConstructorReturn(self, call) {
	    if (!self) {
	        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}
	function _inherits(subClass, superClass) {
	    if (typeof superClass !== "function" && superClass !== null) {
	        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var gatsby_link_4 = __webpack_require__(68);
	var React = __webpack_require__(1);
	var HeaderMenu_2 = __webpack_require__(130);
	var SidebarMenu_1 = __webpack_require__(193);
	var semantic_ui_react_10 = __webpack_require__(21);
	__webpack_require__(218);
	__webpack_require__(216);
	__webpack_require__(217);
	__webpack_require__(215);
	exports.menuItems = [{ name: "Home", path: "/", exact: true, icon: "home", inverted: true }, { name: "About", path: "/about/", exact: true, icon: "info circle" }, { name: "Blog", path: "/blog/", exact: false, icon: "newspaper" }];
	var DefaultLayout = function (_React$PureComponent) {
	    _inherits(DefaultLayout, _React$PureComponent);
	    function DefaultLayout() {
	        _classCallCheck(this, DefaultLayout);
	        return _possibleConstructorReturn(this, (DefaultLayout.__proto__ || Object.getPrototypeOf(DefaultLayout)).apply(this, arguments));
	    }
	    _createClass(DefaultLayout, [{
	        key: "render",
	        value: function render() {
	            var pathname = this.props.location.pathname;
	            var isHome = pathname === "/";
	            return React.createElement(semantic_ui_react_10.Sidebar.Pushable, { as: semantic_ui_react_10.Segment }, React.createElement(SidebarMenu_1.default, { Link: gatsby_link_4.default, pathname: pathname, items: exports.menuItems, visible: false }), React.createElement(semantic_ui_react_10.Sidebar.Pusher, { style: { minHeight: "100vh" } }, isHome ? null : React.createElement(HeaderMenu_2.default, { Link: gatsby_link_4.default, pathname: pathname, items: exports.menuItems }), React.createElement("div", { style: { paddingBottom: 60 } }, this.props.children()), React.createElement(semantic_ui_react_10.Segment, { inverted: true, vertical: true, style: { position: "absolute", bottom: 0, width: "100%" } }, React.createElement(semantic_ui_react_10.Container, { textAlign: "center" }, React.createElement("p", null, "Powered with ", React.createElement(semantic_ui_react_10.Icon, { name: "heart" }), " by Gatsby 1.0")))));
	        }
	    }]);
	    return DefaultLayout;
	}(React.PureComponent);
	exports.default = DefaultLayout;

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-tsx-f7bbc4c32dcf16c5a191.js